var WidgetManager = /** @class */ (function () {
    function WidgetManager() {
    }
    WidgetManager.prototype.resolveManager = function (callback) {
        window.TL.modules.run(function (_require) {
            callback(_require('int/widgets-manager'));
        });
    };
    WidgetManager.prototype.show = function (params, element, showCb) {
        this.resolveManager(function (widgetsManager) {
            widgetsManager.embed(params.kind, params, element, showCb);
        });
    };
    WidgetManager.prototype.resize = function (params) {
        this.resolveManager(function (widgetsManager) {
            widgetsManager.resize(params.kind, params);
        });
    };
    WidgetManager.prototype.hide = function (params) {
        this.resolveManager(function (widgetsManager) {
            widgetsManager.close(params.kind, params);
        });
    };
    WidgetManager.prototype.destroy = function (params) {
        this.resolveManager(function (widgetsManager) {
            widgetsManager.destroy(params.kind, params);
        });
    };
    return WidgetManager;
}());
export { WidgetManager };
